<ng-container *ngIf="loaded; else loadingContent">
    <nav class="navbar navbar-expand-xl nav-root" #navRootEl>
        <ng-container *ngTemplateOutlet="navbarTemplate"></ng-container>
    </nav>
</ng-container>

<ng-template #navbarDefault>
    <div class="container">
        <a class="navbar-brand" [routerLink]="['/home']">
            <img *ngIf="setupService.layout.logo" [src]="setupService.layout.logo" alt="Logo" height="80px" />
        </a>
        <button class="navbar-toggler" type="button" (click)="toggleCollapse()">
            <fa-icon [icon]="hamburger"></fa-icon>
        </button>
        <div
            class="collapse navbar-collapse navbar-fancy"
            id="menuNavbar"
            [ngbCollapse]="isCollapsed"
            [class.production]="production"
        >
            <ul class="navbar-nav mr-auto" *ngIf="statusCode <= 1">
                <ng-container *ngFor="let item of registers">
                    <ng-container *ngIf="item.subItens?.length > 0; then dropdown; else simple"> </ng-container>
                    <ng-template #dropdown>
                        <li
                            class="nav-item nav-item-dropdown"
                            [class.active]="departmentActiveRoute()"
                            ngbDropdown
                            [autoClose]="false"
                            [container]="window.innerWidth >= 1050 ? 'body' : null"
                            dropdownClass="dropdown-nav-menu"
                            #dropDepto="ngbDropdown"
                            (mouseenter)="onDropMouseEnter(dropDepto)"
                            (mouseleave)="onItemMouseLeave(dropDepto, $event)"
                        >
                            <a class="nav-link" id="dropTogglerDepto" ngbDropdownToggle>{{ item.title }}</a>
                            <div ngbDropdownMenu (mouseleave)="onDropMouseLeave(dropDepto)">
                                <ng-container *ngFor="let subitem of item.subItens">
                                    <ng-container
                                        *ngIf="subitem.children?.length > 0; then secondDrop; else simpleChild"
                                    ></ng-container>
                                    <ng-template #secondDrop>
                                        <li
                                            class="nav-item-dropdown dropdown-submenu"
                                            ngbDropdown
                                            dropdownClass="dropdown-submenu"
                                            #dropSecondDrop="ngbDropdown"
                                            (mouseenter)="onDropMouseEnter(dropSecondDrop)"
                                            (mouseleave)="onDropMouseLeave(dropSecondDrop)"
                                        >
                                            <a class="nav-link" ngbDropdownItem ngbDropdownToggle>{{
                                                subitem.title
                                            }}</a>
                                            <div ngbDropdownMenu (mouseleave)="onDropMouseLeave(dropSecondDrop)">
                                                <ng-container *ngFor="let secondLayer of subitem.children">
                                                    <a
                                                        ngbDropdownItem
                                                        class="nav-link"
                                                        [routerLink]="['/' + secondLayer.routerLink]"
                                                        (click)="onDropClick(dropDepto)"
                                                        *ngIf="secondLayer.routerType != 2; else externalLink"
                                                    >
                                                        {{ secondLayer.title }}
                                                    </a>
                                                    <ng-template #externalLink>
                                                        <a
                                                            ngbDropdownItem
                                                            class="nav-link"
                                                            [href]="secondLayer.routerLink"
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            {{ secondLayer.title }}
                                                        </a>
                                                    </ng-template>
                                                </ng-container>
                                            </div>
                                        </li>
                                    </ng-template>
                                    <ng-template #simpleChild>
                                        <a
                                            ngbDropdownItem
                                            class="nav-link"
                                            [routerLink]="['/' + subitem.routerLink]"
                                            (click)="onDropClick(dropDepto)"
                                            *ngIf="subitem.routerType != 2; else externalLink"
                                        >
                                            {{ subitem.title }}
                                        </a>
                                        <ng-template #externalLink>
                                            <a
                                                ngbDropdownItem
                                                class="nav-link"
                                                [href]="subitem.routerLink"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {{ subitem.title }}
                                            </a>
                                        </ng-template>
                                    </ng-template>
                                </ng-container>
                            </div>
                        </li>
                    </ng-template>
                    <ng-template #simple>
                        <li class="nav-item" [class.active]="activeRoute === '/' + item.item.routerLink">
                            <a
                                class="nav-link"
                                [routerLink]="['/' + item.item.routerLink]"
                                (click)="onItemClick(item)"
                                *ngIf="item.item.routerType != 2; else externalLink"
                                >{{ item.title }}</a
                            >
                            <ng-template #externalLink>
                                <a
                                    class="nav-link"
                                    [href]="item.item.routerLink"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    >{{ item.title }}</a
                                >
                            </ng-template>
                        </li>
                    </ng-template>
                </ng-container>
                <li class="nav-item" [class.active]="activeRoute === '/contact'">
                    <!-- prettier-ignore -->
                    <a class="nav-link" [routerLink]="['/contact']">{{ "MENU.CONTACT" | translate }}</a>
                </li>
                <li class="nav-item highlight" *ngIf="setupService.urlReturn">
                    <a class="nav-link" [href]="setupService.urlReturn" target="_blank" rel="noopener noreferrer">{{
                        "PAGES.INSTITUTIONAL" | translate
                    }}</a>
                </li>
            </ul>
        </div>
    </div>
</ng-template>

<ng-template #navbarCentered>
    <ng-container *ngIf="window.innerWidth >= 1200">
        <div class="collapse navbar-collapse navbar-centered" id="menuNavbar" [ngbCollapse]="isCollapsed">
            <div class="container">
                <ul class="navbar-nav mr-auto" *ngIf="statusCode <= 1">
                    <ng-container *ngFor="let item of registers.slice(0, registers.length / 2)">
                        <!-- prettier-ignore -->
                        <ng-container *ngIf="item.subItens?.length > 1; then dropdown else simple"></ng-container>
                        <ng-template #dropdown>
                            <li
                                class="nav-item nav-item-dropdown"
                                [class.active]="departmentActiveRoute()"
                                ngbDropdown
                                #dropDepto="ngbDropdown"
                                (mouseenter)="onDropMouseEnter(dropDepto)"
                                (mouseleave)="onDropMouseLeave(dropDepto)"
                                (click)="onDropClick(dropDepto)"
                            >
                                <a class="nav-link" id="dropTogglerDepto">{{ item.title }}</a>
                                <div ngbDropdownMenu>
                                    <a
                                        [routerLink]="['/' + subitem.routerLink]"
                                        ngbDropdownItem
                                        *ngFor="let subitem of item.subItens"
                                        >{{ subitem.title }}</a
                                    >
                                </div>
                            </li>
                        </ng-template>
                        <ng-template #simple>
                            <!-- prettier-ignore -->
                            <li
            class="nav-item"
            [class.active]="activeRoute === '/' + item.item.routerLink">
            <a
                class="nav-link"
                [routerLink]="['/' + item.item.routerLink]"
                (click)="isCollapsed = false"
                *ngIf="
                    item.item.routerType != 2;
                    else externalLink
                "
                >{{ item.title }}</a
            >
            <ng-template #externalLink>
                <a
                    class="nav-link"
                    [href]="item.item.routerLink"
                    target="_blank"
                    rel="noopener noreferrer"
                    >{{ item.title }}</a
                >
            </ng-template>
        </li>
                        </ng-template>
                    </ng-container>
                    <div class="logo">
                        <a class="navbar-brand" [routerLink]="['/home']">
                            <img
                                *ngIf="setupService.layout.logo"
                                [src]="setupService.layout.logo"
                                alt="Logo"
                                height="60px"
                            />
                        </a>
                    </div>
                    <ng-container *ngFor="let item of registers.slice(registers.length / 2, registers.length)">
                        <!-- prettier-ignore -->
                        <ng-container *ngIf="item.subItens?.length > 1; then dropdown else simple"></ng-container>
                        <ng-template #dropdown>
                            <li
                                class="nav-item nav-item-dropdown"
                                [class.active]="departmentActiveRoute()"
                                ngbDropdown
                                #dropDepto="ngbDropdown"
                                (mouseenter)="onDropMouseEnter(dropDepto)"
                                (mouseleave)="onDropMouseLeave(dropDepto)"
                                (click)="onDropClick(dropDepto)"
                            >
                                <a class="nav-link" id="dropTogglerDepto">{{ item.title }}</a>
                                <div ngbDropdownMenu>
                                    <a
                                        [routerLink]="['/' + subitem.routerLink]"
                                        ngbDropdownItem
                                        *ngFor="let subitem of item.subItens"
                                        >{{ subitem.title }}</a
                                    >
                                </div>
                            </li>
                        </ng-template>
                        <ng-template #simple>
                            <!-- prettier-ignore -->
                            <li
            class="nav-item"
            [class.active]="activeRoute === '/' + item.item.routerLink">
            <a
                class="nav-link"
                [routerLink]="['/' + item.item.routerLink]"
                (click)="isCollapsed = false"
                *ngIf="
                    item.item.routerType != 2;
                    else externalLink
                "
                >{{ item.title }}</a
            >
            <ng-template #externalLink>
                <a
                    class="nav-link"
                    [href]="item.item.routerLink"
                    target="_blank"
                    rel="noopener noreferrer"
                    >{{ item.title }}</a
                >
            </ng-template>
        </li>
                        </ng-template>
                    </ng-container>
                    <li class="nav-item" [class.active]="activeRoute === '/contact'">
                        <!-- prettier-ignore -->
                        <a class="nav-link" [routerLink]="['/contact']">{{ "MENU.CONTACT" | translate }}</a>
                    </li>
                </ul>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="window.innerWidth < 1200">
        <ng-container *ngTemplateOutlet="navbarSimple"></ng-container>
    </ng-container>
</ng-template>

<ng-template #navbarSimple>
    <div class="container">
        <a class="navbar-brand mr-auto" [routerLink]="['/home']">
            <img *ngIf="setupService.layout.logo" [src]="setupService.layout.logo" alt="Logo" height="80px" />
        </a>
        <button class="navbar-toggler" type="button" (click)="toggleCollapse()">
            <fa-icon [icon]="hamburger"></fa-icon>
        </button>
        <div class="collapse navbar-collapse" id="menuNavbar" [ngbCollapse]="isCollapsed">
            <ul class="navbar-nav mr-auto" *ngIf="statusCode <= 1">
                <ng-container *ngFor="let item of registers">
                    <ng-container *ngIf="item.subItens?.length > 0; then dropdown; else simple"></ng-container>
                    <ng-template #dropdown>
                        <li
                            class="nav-item nav-item-dropdown"
                            [class.active]="departmentActiveRoute()"
                            ngbDropdown
                            [autoClose]="false"
                            [container]="window.innerWidth >= 1050 ? 'body' : null"
                            #dropDepto="ngbDropdown"
                            (mouseenter)="onDropMouseEnter(dropDepto)"
                        >
                            <a class="nav-link" id="dropTogglerDepto" ngbDropdownToggle>{{ item.title }}</a>
                            <div ngbDropdownMenu (mouseleave)="onDropMouseLeave(dropDepto)">
                                <ng-container *ngFor="let subitem of item.subItens">
                                    <ng-container
                                        *ngIf="subitem.children?.length > 0; then secondDrop; else simpleChild"
                                    ></ng-container>
                                    <ng-template #secondDrop>
                                        <li
                                            class="nav-item-dropdown dropdown-submenu"
                                            ngbDropdown
                                            dropdownClass="dropdown-submenu"
                                            #dropSecondDrop="ngbDropdown"
                                            (mouseenter)="onDropMouseEnter(dropSecondDrop)"
                                            (mouseleave)="onDropMouseLeave(dropSecondDrop)"
                                        >
                                            <a class="nav-link" ngbDropdownItem ngbDropdownToggle>{{
                                                subitem.title
                                            }}</a>
                                            <div ngbDropdownMenu (mouseleave)="onDropMouseLeave(dropSecondDrop)">
                                                <ng-container *ngFor="let secondLayer of subitem.children">
                                                    <a
                                                        ngbDropdownItem
                                                        class="nav-link"
                                                        [routerLink]="['/' + secondLayer.routerLink]"
                                                        (click)="onDropClick(dropDepto)"
                                                        *ngIf="secondLayer.routerType != 2; else externalLink"
                                                    >
                                                        {{ secondLayer.title }}
                                                    </a>
                                                    <ng-template #externalLink>
                                                        <a
                                                            ngbDropdownItem
                                                            class="nav-link"
                                                            [href]="secondLayer.routerLink"
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            {{ secondLayer.title }}
                                                        </a>
                                                    </ng-template>
                                                </ng-container>
                                            </div>
                                        </li>
                                    </ng-template>
                                    <ng-template #simpleChild>
                                        <a
                                            ngbDropdownItem
                                            class="nav-link"
                                            [routerLink]="['/' + subitem.routerLink]"
                                            (click)="onDropClick(dropDepto)"
                                            *ngIf="subitem.routerType != 2; else externalLink"
                                        >
                                            {{ subitem.title }}
                                        </a>
                                        <ng-template #externalLink>
                                            <a
                                                ngbDropdownItem
                                                class="nav-link"
                                                [href]="subitem.routerLink"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {{ subitem.title }}
                                            </a>
                                        </ng-template>
                                    </ng-template>
                                </ng-container>
                            </div>
                        </li>
                    </ng-template>
                    <ng-template #simple>
                        <li class="nav-item" [class.active]="activeRoute === '/' + item.item.routerLink">
                            <a
                                class="nav-link"
                                [routerLink]="['/' + item.item.routerLink]"
                                (click)="onItemClick(item)"
                                *ngIf="item.routerType != 2; else externalLink"
                            >
                                {{ item.title }}
                            </a>
                            <ng-template #externalLink>
                                <a
                                    class="nav-link"
                                    [href]="item.item.routerLink"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {{ item.title }}
                                </a>
                            </ng-template>
                        </li>
                    </ng-template>
                </ng-container>
                <li class="nav-item" [class.active]="activeRoute === '/contact'">
                    <a class="nav-link" [routerLink]="['/contact']">{{ "MENU.CONTACT" | translate }}</a>
                </li>
                <li class="nav-item highlight" *ngIf="setupService.urlReturn">
                    <a class="nav-link" [href]="setupService.urlReturn" target="_blank" rel="noopener noreferrer">
                        {{ "PAGES.INSTITUTIONAL" | translate }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</ng-template>

<ng-template #loadingContent>
    <ngx-skeleton height="116px" width="100%"></ngx-skeleton>
</ng-template>
